import { memo, useEffect, useState } from "react";
import { Organization_GetPage_RequestQuery, OrganizationAPIs } from "~/common/typescript/apis/OrganizationAPIs";
import OrganizationItem from "./OrganizationItem";
import { AC_Organization_Role } from "~/common/typescript/services/access_control/AC_Organization";
import { Organization_Base } from "~/common/typescript/models/Organization";
import styled from "styled-components";
import { Button, Input, Pagination, Spin } from "antd";

const ListPageOrg = () => {
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [filterPhoneNumber, setFilterPhoneNumber] = useState<string>('');

  const [organizations, setOrganizations] = useState<Organization_Base[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = () => {
    setLoading(true);
    const request: Organization_GetPage_RequestQuery = {
      page: page,
      pageSize: pageSize,
      phone_number: filterPhoneNumber,
    };
    OrganizationAPIs.remote_getPage(request)
      .then((response) => {
        setOrganizations(response.results || []);
        setTotal(response.pagination?.total || 0);
      })
      .catch((error) => {
        console.error("Error fetching organizations:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSearch = () => {
    setPage(1);
    setFilterPhoneNumber(phoneNumber);
  };

  useEffect(() => {
    setPage(1);
  }, [filterPhoneNumber]);

  useEffect(() => {
    fetchData();
  }, [page, pageSize, filterPhoneNumber]);

  return (
    <UI_Wrapper>
      <UI_Header>
        <UI_TitleRow>
          <UI_Title>Danh sách doanh nghiệp (cho admin)</UI_Title>
          {total > 0 && <UI_Badge>{total}</UI_Badge>}
        </UI_TitleRow>

        <UI_FilterGroup>
          <Input
            value={phoneNumber}
            placeholder="Số điện thoại"
            allowClear
            onChange={(e) => setPhoneNumber(e.target.value)}
            onPressEnter={handleSearch}
            style={{ width: 180 }}
            size="middle"
          />
          <Button
            type="primary"
            onClick={handleSearch}
          >
            Tìm kiếm
          </Button>
        </UI_FilterGroup>
      </UI_Header>

      <Spin spinning={loading}>
        <UI_List>
          {organizations?.map((organization) => (
            <OrganizationItem
              key={organization.id}
              organization={organization}
              role={AC_Organization_Role.ORGANIZATION_OWNER}
            />
          ))}
        </UI_List>

        {!loading && organizations.length === 0 && (
          <div style={{ padding: 16, textAlign: 'center', color: '#94a3b8' }}>
            Không tìm thấy doanh nghiệp nào
          </div>
        )}
      </Spin>

      {total > 0 && (
        <UI_PaginationWrapper>
          <Pagination
            current={page}
            pageSize={pageSize}
            total={total}
            onChange={(newPage, newPageSize) => {
              setPage(newPage);
              setPageSize(newPageSize);
            }}
            showSizeChanger
            pageSizeOptions={['10', '20', '50']}
            showTotal={(total) => `Tổng cộng ${total} doanh nghiệp`}
          />
        </UI_PaginationWrapper>
      )}
    </UI_Wrapper>
  );
};

export default memo(ListPageOrg);

const UI_Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #f1f5f9;
`;

const UI_Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`;

const UI_TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const UI_Title = styled.h2`
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
`;

const UI_Badge = styled.span`
  background: #f1f5f9;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
`;

const UI_FilterGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 576px) {
    width: 100%;

    input {
      flex: 1;
    }
  }
`;

const UI_List = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 10px;
`;

const UI_PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
  margin-top: 4px;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;